import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const ceilingOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "手机账号",
            prop: "mobile",
            type: "input",
            formsolt: true,
        },
        {
            label: "名字",
            prop: "name",
            type: "input",
            formsolt: true,
        },
        {
            label: "金额上限",
            prop: "ceiling",
            type: "input"
        },
        {
            label: "积分上限",
            prop: "integralValue",
            type: "input"
        }
    ]
};